import type { ComponentMeta } from "@mijalowcode/types";
import { ComponentCategory, PropType } from "@mijalowcode/types";

export const TableMeta: ComponentMeta = {
  componentName: "Table",
  package: "@mijadesign/web",
  title: "表格",
  description: "展示行列数据",
  category: ComponentCategory.DATA_DISPLAY,
  visibleInComponentPanel: false,
  icon: "TableOutlined",
  canHaveChildren: false,
  designToken: {
    fields: [
      { name: "headerBg", label: "表头背景", type: "color" },
      { name: "headerColor", label: "表头文字", type: "color" },
      { name: "rowHoverBg", label: "行悬浮背景", type: "color" },
      { name: "borderColor", label: "边框颜色", type: "color" },
      {
        name: "cellPaddingBlock",
        label: "单元格纵向间距",
        type: "number",
        min: 0,
        max: 48,
      },
    ],
  },
  props: [
    {
      name: "columns",
      label: "列配置",
      type: PropType.TABLE_COLUMNS,
      defaultValue: [
        { title: "姓名", dataIndex: "name", key: "name" },
        { title: "年龄", dataIndex: "age", key: "age" },
        { title: "地址", dataIndex: "address", key: "address" },
      ],
      description: "表格列配置",
      group: "数据",
    },
    {
      name: "dataSource",
      label: "数据源",
      type: PropType.JSON,
      defaultValue: [
        { key: "1", name: "张三", age: 32, address: "北京市" },
        { key: "2", name: "李四", age: 28, address: "上海市" },
      ],
      description: "表格数据",
      group: "数据",
    },
    {
      name: "bordered",
      label: "边框",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "样式",
    },
    {
      name: "size",
      label: "尺寸",
      type: PropType.ENUM,
      defaultValue: "middle",
      options: [
        { label: "大", value: "large" },
        { label: "中", value: "middle" },
        { label: "小", value: "small" },
      ],
      group: "基础",
    },
    {
      name: "loading",
      label: "加载中",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "状态",
    },
    {
      name: "pagination",
      label: "分页",
      type: PropType.JSON,
      defaultValue: { pageSize: 10 },
      description: "分页配置,false 关闭",
      group: "功能",
    },
    // {
    //   name: "rowSelection",
    //   label: "行选择",
    //   type: PropType.JSON,
    //   description: "行选择配置",
    //   group: "功能",
    // },
    {
      name: "scroll",
      label: "滚动配置",
      type: PropType.JSON,
      description: "如 { x: 1000, y: 500 }",
      group: "布局",
    },
    {
      name: "showHeader",
      label: "显示表头",
      type: PropType.BOOLEAN,
      defaultValue: true,
      group: "基础",
    },
  ],
  defaultProps: {
    columns: [
      { title: "姓名", dataIndex: "name", key: "name" },
      { title: "年龄", dataIndex: "age", key: "age" },
      { title: "地址", dataIndex: "address", key: "address" },
    ],
    dataSource: [
      { key: "1", name: "张三", age: 32, address: "北京市" },
      { key: "2", name: "李四", age: 28, address: "上海市" },
    ],
  },
  preview: [
    {
      title: "基础表格",
      props: {
        columns: [
          { title: "姓名", dataIndex: "name", key: "name" },
          { title: "年龄", dataIndex: "age", key: "age" },
          { title: "地址", dataIndex: "address", key: "address" },
        ],
        dataSource: [
          { key: "1", name: "张三", age: 32, address: "北京市" },
          { key: "2", name: "李四", age: 28, address: "上海市" },
        ],
      },
    },
    {
      title: "带边框",
      props: {
        bordered: true,
        size: "small",
        columns: [
          { title: "商品", dataIndex: "name", key: "name" },
          { title: "数量", dataIndex: "count", key: "count" },
          { title: "状态", dataIndex: "status", key: "status" },
        ],
        dataSource: [
          { key: "1", name: "基础版", count: 12, status: "在售" },
          { key: "2", name: "专业版", count: 8, status: "售罄" },
        ],
      },
    },
  ],
  npm: {
    package: "@mijadesign/web",
    exportName: "Table",
  },
  snippet: {
    componentName: "Table",
    package: "@mijadesign/web",
    props: {
      columns: [
        { title: "姓名", dataIndex: "name", key: "name" },
        { title: "年龄", dataIndex: "age", key: "age" },
        { title: "地址", dataIndex: "address", key: "address" },
      ],
      dataSource: [
        { key: "1", name: "张三", age: 32, address: "北京市" },
        { key: "2", name: "李四", age: 28, address: "上海市" },
      ],
    },
  },
};
